import { render, staticRenderFns } from "./CourseRegistration.html?vue&type=template&id=3de65efc&scoped=true&"
import script from "./CourseRegistration.vue?vue&type=script&lang=js&"
export * from "./CourseRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CourseRegistration.scss?vue&type=style&index=0&id=3de65efc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de65efc",
  null
  
)

export default component.exports